import {Button, Input, message, Modal, Switch} from "antd";
import CustomButton from "../../../components/element/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowCircleDown, faArrowCircleUp, faRemove} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import EntityApi from "../../../api/EntityApi";

const { TextArea } = Input;

const AnswerForm = ({answer, index, answers, reload}) => {

    const [isEdit, setEdit] = React.useState(false);
    const [formText, setFormText] = React.useState('');
    const [formStatus, setFormStatus] = React.useState(false);
    const [viewText, setViewText] = React.useState('');

    const onSave = () => {

        if (formText === '') {
            message.error('Введите текст ответа');
            return false;
        }

        EntityApi.put('private/testing/answer/' + answer.id, {
            text: formText,
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                setViewText(formText);
                setEdit(false);
            }
        }).catch((error) => {
            console.error(error.message());
            message.error('Ошибка сохранения');
        })

    }

    const onChangeStatus = (status) => {
        setFormStatus(status);

        EntityApi.put('private/testing/answer/status/' + answer.id, {
            status: status ? 1 : 0,
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                message.success('Статус сохранен');
            }
        }).catch((error) => {
            console.error(error.message());
            message.error('Ошибка сохранения');
        })

    }

    const onConfirmRemove = () => {
        Modal.confirm({
            title: 'Подтвердите удаление ответа',
            content: 'Вы действительно хотите удалить данный ответ?',
            onOk: () => {
                onRemove();
            }
        });
    }

    const onRemove = () => {

        EntityApi.delete('private/testing/answer', answer.id).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                reload();
            }
        }).catch((error) => {
            console.error(error.message());
            message.error('Ошибка удаления');
        })

    }

    const onSort = (id, direction) => {
        EntityApi.post('private/testing/answer/sort', id, {
            'direction': direction
        }).then((data) => {
            reload();
        })
    }

    React.useEffect(() => {
        setFormText(answer.text);
        setViewText(answer.text);
        setFormStatus(answer.is_true)
    }, [])

    return <div>

        {
            isEdit &&
            <div className={'w-full flex justify-between'}
                 style={{marginBottom: '0.75rem'}}>
                <div className={'w-full mr-3'}>
                    <TextArea value={formText} onChange={(e) => setFormText(e.target.value)}/>
                </div>
                <div>
                    <Button type={'primary'}
                            onClick={() => onSave()}>Сохранить</Button>
                </div>
            </div>
        }
        {
            !isEdit &&
            <div className={'flex justify-between'} style={{marginBottom: '0.75rem'}}>
                <div onClick={() => setEdit(true)}
                     className={'btn bg-slate-150 hover:bg-slate-200 flex mr-3'} style={{width: 'calc(100% - 280px)'}}>
                    <div className={'w-full'} style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                        {viewText}
                    </div>
                </div>
                <div className={'mr-1'}>
                    <Switch checkedChildren="Верный" checked={formStatus} unCheckedChildren="Неверный"
                            onChange={(checked) => onChangeStatus(checked)}/>
                </div>
                <div className={'flex mr-1'}>
                    <div className={'mr-1'}>
                        {
                            index > 0 ?
                                <CustomButton onClick={() => onSort(answer.id, 'down')}
                                    text={<FontAwesomeIcon icon={faArrowCircleUp}/>}
                                    type={"info"}/>
                                :
                                <CustomButton
                                    text={<FontAwesomeIcon icon={faArrowCircleUp}/>}
                                    disabled={true} type={"default"}/>
                        }
                    </div>
                    <div>
                        {
                            index < answers.length - 1 ?
                                <CustomButton onClick={() => onSort(answer.id, 'up')}
                                    text={<FontAwesomeIcon icon={faArrowCircleDown}/>}
                                    type={"info"}/>
                                :
                                <CustomButton
                                    text={<FontAwesomeIcon icon={faArrowCircleDown}/>}
                                    disabled={true} type={"default"}/>
                        }
                    </div>
                </div>
                <div>
                    <CustomButton onClick={onConfirmRemove} text={<FontAwesomeIcon icon={faRemove}/>} type={"error"}/>
                </div>
            </div>
        }
    </div>

}

export default AnswerForm;
